import { observer } from 'mobx-react-lite';
import { DialogId } from 'account/recurring-payment/lib';
import { useButtonTranslations, useUpdateTranslations } from 'account/recurring-payment/lib/translations';
import { Button } from 'components/buttons/button';
import { ButtonType } from 'components/buttons/button-types';
import { Card } from 'components/cards/card';
import { CardThemeType } from 'components/cards/card-type';
import { closeDialog, DialogWrapper } from 'components/dialog-wrapper';
import ButtonToolbar from './button-toolbar';

const SelectPaymentDateDialog = observer(() => {
  const { paymentDate, datePickerText } = useUpdateTranslations();
  const { back, confirm } = useButtonTranslations();

  const now = new Date();
  const { year, month } = { year: now.getFullYear(), month: now.getMonth() };
  const dayCount = new Date(year, month + 1, 0).getDate();

  const days = Array.from({ length: dayCount }, (_, i) => i + 1);

  const backButtonMeta = {
    name: 'back',
    title: back,
    type: ButtonType.OutlineDark,
  };

  const confirmButtonMeta = {
    name: 'confirm',
    title: confirm,
    type: ButtonType.Primary,
  };

  const getDayClassName = (day: number) => day == 1 ? 'selected' : undefined;

  return <DialogWrapper id={DialogId.selectPaymentDate}>
    <Card backgroundType={CardThemeType.Light}>
      <>
        <h5>{paymentDate.select}</h5>

        <p>
          {datePickerText}
        </p>

        <ul>
          {days.map(day => <li key={`day_${day}`} className={getDayClassName(day)}>
            <span>{day < 10 ? `0${day}` : day}</span>
          </li>)}
        </ul>

        <ButtonToolbar>
          <>
            <Button meta={backButtonMeta}
                    onClick={() => closeDialog(DialogId.selectPaymentDate)} />
            <Button meta={confirmButtonMeta} />
          </>
        </ButtonToolbar>
      </>
    </Card>
  </DialogWrapper>
});
export default SelectPaymentDateDialog;